export default __webpack_public_path__ + "static/media/a7.9861d22b.webp";